import { useIsTreatmentVariantByUser } from "../../utils";
import { VariantEnum } from "../../types";
import { PAWS_BRAINTREE_CC_EXPERIMENT_KEY } from "../../experimentKeys";

export { PAWS_BRAINTREE_CC_EXPERIMENT_KEY };

/**
 * Braintree CC experiment gate. Adds `isControl` so callers can route only an
 * explicit `control` assignment to the legacy CCP processor, while an
 * unresolved / failed / absent lookup (`variant === undefined`) defaults to
 * treatment (BRT) at 100% rollout.
 */
export const usePawsBraintreeCC = (): {
  isTreatment: boolean;
  isControl: boolean;
  isResolved: boolean;
} => {
  const { isTreatment, isResolved, variant } = useIsTreatmentVariantByUser(
    PAWS_BRAINTREE_CC_EXPERIMENT_KEY
  );

  return {
    isTreatment,
    isControl: variant === VariantEnum.CONTROL,
    isResolved
  };
};
